import { Component, OnInit } from '@angular/core';
import { PqrsService } from 'src/app/servicios/public/pqrs.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Loading } from 'src/app/Class/Loading';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-pqrs-consultar',
  templateUrl: './pqrs-consultar.component.html',
  styleUrls: ['./pqrs-consultar.component.css']
})
export class PqrsConsultarComponent implements OnInit {

  public url: string = null;
  public datospqrs: any = { archivos:[], archivosRespuestas:[] };
  public respuesta: any = [];
  public formconsultar: any ;
  public id: any;

  constructor( private servi: PqrsService, private form: FormBuilder, private rout: ActivatedRoute, public loading: Loading) {

    this.url = this.servi.getServe();

    this.rout.params.subscribe(parametros => { this.id = parametros['id']; });
    if (this.id != null) {
      this.formconsultar = this.id;
      this.loading.estado = true;
      this.servi.consultarPQRS(this.id).subscribe(data => {
        if (data['pqrs']) {
          this.datospqrs = data['pqrs'];
          this.respuesta = this.datospqrs.respuesta;
        } else {
          Swal.fire({ type: 'warning', title: 'No se encontro su solicitud', showConfirmButton: false, timer: 1500 });
         }
        });
      this.loading.estado = false;
    }

  }
  ngOnInit() {}

  public consultar() {

    this.loading.estado = true;
    this.servi.consultarPQRS(this.formconsultar).subscribe(data => {
        if (data['pqrs']) {
          this.datospqrs = data['pqrs'];
          this.respuesta = this.datospqrs.respuesta;
        } else {
          Swal.fire({ type: 'warning', title: 'No se encontro su solicitud', showConfirmButton: false, timer: 1500 });
          this.datospqrs = null;
          this.respuesta = [];
        }
        });
    this.loading.estado = false;
  }

}
